import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { debounceTime, Subject } from 'rxjs';
import AppValues from '../../app.values';

@Directive({
  selector: '[appDebounceKeyboardKeyup]',
})
export class DebounceKeyboardKeyUpDirective {
  @Input({ required: false }) public debounceTime: number = AppValues.DEBOUNCE_TIME;

  @Output() public debounceKeyUp: EventEmitter<KeyboardEvent> = new EventEmitter<KeyboardEvent>();

  private keyboardClick$: Subject<KeyboardEvent> = new Subject();

  @HostListener('keyup', ['$event'])
  public clickEvent(event: KeyboardEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.keyboardClick$.next(event);
  }

  constructor() {
    this.keyboardClick$
      .pipe(takeUntilDestroyed(), debounceTime(this.debounceTime))
      .subscribe((event: KeyboardEvent) => {
        this.debounceKeyUp.emit(event);
      });
  }
}
